// Template Generated by DataExtraction.py at 1716420056

import CreditCardEn1 from "../../Forms/Credit Card/CreditCard_En1.png";
import CreditCardEn1Labels from "../../Labels/Credit Card/CreditCard_En1.json";
import CreditCardFr1 from "../../Forms/Credit Card/CreditCard_Fr1.png";
import CreditCardFr1Labels from "../../Labels/Credit Card/CreditCard_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CreditCardFr1Labels : CreditCardEn1Labels;
    const formImage = isFrench ? CreditCardFr1 : CreditCardEn1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */
    const common = data.common;
    const sub1 = data.subscriber;
    const sub2 = data.jointSubscriber;

    let subNames = sub1.firstName + (sub1.lastName ? " " + sub1.lastName : "");

    if (common.subscriber2Include) {
        subNames += " & " + sub2.firstName + (sub2.lastName ? " " + sub2.lastName : "");
    }

    // Drawing the form
    drawText(common.agentCode, "drName");
    drawText(sub1.name, "sub1Name");
    drawText(moment(new Date()).format("YYYY-MM-DD"), "sub1SignDate");
    if (common.subscriber2Include) {
        drawText(sub2.name, "sub2Name");
        drawText(moment(new Date()).format("YYYY-MM-DD"), "sub2SignDate");
    }
    drawText(subNames, "subNames");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CreditCardFr1Labels : CreditCardEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    const subscriber2Include = state.common.subscriber2Include

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))],
        });
    }


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    